"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationClose = exports.NavigationBack = exports.NavigationMenuContent = exports.NavigationMenuTrigger = exports.NavigationMenuItem = exports.NavigationMenuList = exports.NavigationMenu = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("../utils"); // Utility for conditional class names
const NavigationMenuContext = (0, react_1.createContext)(undefined);
const useNavigationMenu = () => {
    const context = (0, react_1.useContext)(NavigationMenuContext);
    if (!context) {
        throw new Error('useNavigationMenu must be used within a NavigationMenu');
    }
    return context;
};
const NavigationMenuItemContext = (0, react_1.createContext)(undefined);
const useNavigationMenuItem = () => {
    const context = (0, react_1.useContext)(NavigationMenuItemContext);
    if (!context) {
        throw new Error('useNavigationMenuItem must be used within a NavigationMenuItem');
    }
    return context;
};
// Main NavigationMenu component
const NavigationMenu = ({ children, className }) => {
    const closeAllMenus = () => {
        // Dispatch a global event to notify all menu items to close
        document.dispatchEvent(new Event('closeAllMenus'));
    };
    const contextValue = (0, react_1.useMemo)(() => ({ closeAllMenus }), []);
    return (react_1.default.createElement(NavigationMenuContext.Provider, { value: contextValue },
        react_1.default.createElement("nav", { className: (0, utils_1.cn)(`${className}`) }, children)));
};
exports.NavigationMenu = NavigationMenu;
// List for the navigation items
const NavigationMenuList = ({ children, className }) => {
    return react_1.default.createElement("ul", { className: (0, utils_1.cn)('flex flex-col space-y-2', className) }, children);
};
exports.NavigationMenuList = NavigationMenuList;
// Each navigation item with internal state management
const NavigationMenuItem = ({ children, className }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const itemRef = (0, react_1.useRef)(null);
    const toggleMenu = () => setIsOpen((prev) => !prev);
    const closeMenu = () => setIsOpen(false);
    // useEffect(() => {
    //   const handleFocusOutside = (event: FocusEvent) => {
    //     if (itemRef.current && !itemRef.current.contains(event.target as Node)) {
    //       closeMenu();
    //     }
    //   };
    //   document.addEventListener('focusin', handleFocusOutside);
    //   return () => {
    //     document.removeEventListener('focusin', handleFocusOutside);
    //   };
    // }, []);
    (0, react_1.useEffect)(() => {
        const handleCloseAllMenus = () => closeMenu();
        document.addEventListener('closeAllMenus', handleCloseAllMenus);
        return () => {
            document.removeEventListener('closeAllMenus', handleCloseAllMenus);
        };
    }, []);
    const contextValue = (0, react_1.useMemo)(() => ({ isOpen, toggleMenu, closeMenu }), [isOpen]);
    return (react_1.default.createElement(NavigationMenuItemContext.Provider, { value: contextValue },
        react_1.default.createElement("li", { ref: itemRef, className: (0, utils_1.cn)('relative', className) }, children)));
};
exports.NavigationMenuItem = NavigationMenuItem;
// Trigger button to toggle the menu
const NavigationMenuTrigger = ({ children, className }) => {
    const { isOpen, toggleMenu } = useNavigationMenuItem();
    return (react_1.default.createElement("button", { onClick: () => {
            toggleMenu();
        }, "aria-expanded": isOpen, className: (0, utils_1.cn)('text-blue-500 hover:text-blue-700 array_link', className, isOpen ? 'active' : 'inactive') }, children));
};
exports.NavigationMenuTrigger = NavigationMenuTrigger;
// Content that appears when the menu is open
const NavigationMenuContent = ({ children, className, responsiveBreakpoint = "sm" }) => {
    const { isOpen, closeMenu } = useNavigationMenuItem();
    const contentRef = (0, react_1.useRef)(null);
    // Close the menu when clicking outside
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (contentRef.current && !contentRef.current.contains(event.target) && !event?.srcElement?.classList?.contains("array_link")) {
                closeMenu();
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, closeMenu]);
    // Handle bubbling clicks on <a> or <Link>
    const handleContentClick = (event) => {
        const target = event.target;
        // Close the menu only for anchor tags or Next.js Link children
        if (target.tagName === 'A' || target.closest('a')) {
            closeMenu();
        }
    };
    return (react_1.default.createElement("div", { ref: contentRef, onClick: handleContentClick, className: (0, utils_1.cn)(`z-[999] absolute top-full mt-2 left-0 w-64 bg-brandWhite border border-grey200 rounded-md shadow-lg transition-all duration-300 ease-in-out ${!isOpen && `${responsiveBreakpoint}:translate-x-0`}`, {
            'transform translate-x-[-100%]': !isOpen,
            'translate-x-0': isOpen,
            'opacity-0 invisible pointer-events-none': !isOpen,
            'opacity-100 visible pointer-events-auto': isOpen,
        }, className) }, children));
};
exports.NavigationMenuContent = NavigationMenuContent;
// Back button for individual menus
const NavigationBack = ({ className, children }) => {
    const { closeMenu } = useNavigationMenuItem();
    const handleCloseClick = (event) => {
        event.stopPropagation(); // Prevent triggering the parent menu's close logic
        closeMenu();
    };
    return (react_1.default.createElement("button", { onClick: handleCloseClick, className: (0, utils_1.cn)('text-red-500 hover:text-red-700', className) }, children));
};
exports.NavigationBack = NavigationBack;
// NavigationClose component to close all menus
const NavigationClose = ({ className, children }) => {
    const { closeAllMenus } = useNavigationMenu();
    return (react_1.default.createElement("button", { onClick: closeAllMenus, className: (0, utils_1.cn)('text-red-500 hover:text-red-700', className) }, children || 'Close All Menus'));
};
exports.NavigationClose = NavigationClose;
